import {
	Accordion,
	Box,
	Button,
	Center,
	ChevronLeftIcon,
	ChevronRightIcon,
	Divider,
	Heading,
	Text,
	useMediaQuery,
	useTheme,
	VStack,
} from "native-base";
import React, { useEffect, useRef, useState } from "react";
import {
	Dimensions,
	FlatList,
	Image,
	Linking,
	Platform,
	SafeAreaView,
	ScrollView,
	TouchableOpacity,
	View,
} from "react-native";
import Xiaomi from "../../../assets/CIP-Flow-diagram.png";
import Vivo from "../../../assets/Vivo-how-does-it-work.jpg";
// import { CIP_BRAND } from "@env";
import { AppText } from "../../components";
import Constants from "../../utils/Constants";
import {
	getBrandHowDoesItWorkImage,
	getBrandLogo,
	isWeb,
} from "../../utils/utils";
import MobileCarousel from "./MobileCarousel";

const { width, height } = Dimensions.get("window");

const BRAND_URL = isWeb() ? Constants.WindowHostname : Constants.CIP_BRAND;

const InfoPages = () => {
	const { colors } = useTheme();
	const flatlistRef = useRef();
	const isDesktopOrLaptop = useMediaQuery({ minWidth: 960 });
	const [currentPage, setCurrentPage] = useState(0);
	const [viewableItems, setViewableItems] = useState([]);

	// const BRAND_IMAGE = () => {
	// 	switch (BRAND_URL) {
	// 		case Constants.XiaomiURL:
	// 			return Xiaomi;
	// 		case Constants.VivoURL:
	// 			return Vivo;

	// 		default:
	// 			return Vivo;
	// 	}
	// };

	const isXiaomi = BRAND_URL === Constants.XiaomiURL;

	const handleDownload = async (fileName) => {
		if (isWeb()) {
			switch (Constants.CIP_BRAND) {
				case Constants.XiaomiURL:
					downloadAPK("https://xiaomiincentives.co.za/CIP/", fileName);
					break;
				case Constants.VivoURL:
					downloadAPK("https://www.vivoincentives.co.za/CIP/", fileName);
					break;
				case Constants.HisenseURL:
					downloadAPK("https://www.vivoincentives.co.za/CIP/", fileName);
					break;
				default:
					break;
			}
		}
	};

	const downloadAPK = (link, fileName) => {
		const linkSource = `${link}${fileName}`;
		const downloadLink = document.createElement("a");

		downloadLink.href = linkSource;
		downloadLink.download = fileName;
		downloadLink.click();
	};

	/**
	 * FAQs
	 */
	const XiaomiFAQ = () => {
		return (
			<Box
				m={3}
				style={
					isDesktopOrLaptop[0]
						? { marginHorizontal: 200 }
						: { marginHorizontal: 5, marginBottom: 200 }
				}
			>
				<Accordion margin="5" allowMultiple>
					<Accordion.Item>
						<Accordion.Summary>
							How the member registration process works?
						</Accordion.Summary>
						<Accordion.Details backgroundColor="#f5f5f5">
							You can register via the web portal or our mobile application by
							clicking on "MEMBER REGISTRATION" and following the prompts. Be
							sure to have a digital copy of your proof of identity as you will
							need to upload it during registration. Once we receive your
							registration request your proof of identity will be moderated and
							your employment verified by the manager registered at that store
							or by a Xiaomi representative where after your account will be
							activated. A benefit card will be shipped to the store you
							registered with.
						</Accordion.Details>
					</Accordion.Item>
					<Accordion.Item>
						<Accordion.Summary>
							How does the Xiaomi Channel Incentive Program work?
						</Accordion.Summary>
						<Accordion.Details backgroundColor="#f5f5f5">
							Sales for incentivized devices are claimed for via our web portal
							or mobile application. Claims are moderated and paid out to an
							online wallet. Funds can be transferred from the online wallet to
							the XIP benefit card which can be used to purchase from any point
							of sale system.
						</Accordion.Details>
					</Accordion.Item>
					<Accordion.Item>
						<Accordion.Summary>
							How to get the Xiaomi XIP mobile application?
						</Accordion.Summary>
						<Accordion.Details backgroundColor="#f5f5f5">
							<Text>
								From Android devices visit the Google Play store or for Apple
								devices visit the Apple App Store and search for the "Xiaomi
								XIP" application. From the mobile application you can register,
								submit claims, transfer funds and manage your account.
								Alternatively you are also able to download the android APK file
								to install the app manually by clicking{" "}
								<Button
									padding={0}
									onPress={() => handleDownload("Xiaomi_XIP.apk")}
									size="md"
									variant="link"
								>
									HERE.
								</Button>
							</Text>
						</Accordion.Details>
					</Accordion.Item>
					<Accordion.Item>
						<Accordion.Summary>
							I cannot log into the XIP website or mobile application?
						</Accordion.Summary>
						<Accordion.Details backgroundColor="#f5f5f5">
							After you submitted your member registration via the web portal or
							mobile application it may take up to three working days to verify
							your proof of identify and employment. If you were already
							registered successfully and you have forgotten your login details,
							please use the Forgot Password link on the login screen to reset
							your password. Alternatively contact Support on 011 504 0010 or
							support@xiaomiincentives.co.za for further assistance.
						</Accordion.Details>
					</Accordion.Item>
				</Accordion>
			</Box>
		);
	};
	const VivoFAQ = () => {
		return (
			<Box
				m={3}
				style={
					isDesktopOrLaptop[0]
						? { marginHorizontal: 200 }
						: { marginHorizontal: 5, marginBottom: 200 }
				}
			>
				<Accordion space={2.5} allowMultiple>
					<Accordion.Item>
						<Accordion.Summary>
							How the member registration process works?
						</Accordion.Summary>
						<Accordion.Details backgroundColor="#f5f5f5">
							You can register via the web portal or our mobile application by
							clicking on "MEMBER REGISTRATION" and following the prompts. Be
							sure to have a digital copy of your proof of identity as you will
							need to upload it during registration. Once we receive your
							registration request your proof of identity will be moderated and
							your employment verified by the manager registered at that store
							or by a vivo representative where after your account will be
							activated. A benefit card will be shipped to the store you
							registered with.
						</Accordion.Details>
					</Accordion.Item>
					<Accordion.Item>
						<Accordion.Summary>
							How does the vivo Channel Incentive Program work?
						</Accordion.Summary>
						<Accordion.Details backgroundColor="#f5f5f5">
							Sales for incentivized devices are claimed for via our web portal
							or mobile application. Claims are moderated and paid out to an
							online wallet. Funds can be transferred from the online wallet to
							the CIP benefit card which can be used to purchase from any point
							of sale system.
						</Accordion.Details>
					</Accordion.Item>
					<Accordion.Item>
						<Accordion.Summary>
							How to get the vivo CIP mobile application?
						</Accordion.Summary>
						<Accordion.Details backgroundColor="#f5f5f5">
							<Text>
								From Android devices visit the Google Play store or for Apple
								devices visit the Apple App Store and search for the "vivo CIP"
								application. From the mobile application you can register,
								submit claims, transfer funds and manage your account.
								Alternatively you are also able to download the android APK file
								to install the app manually by clicking{" "}
								<Button
									padding={0}
									onPress={() => handleDownload("Vivo_CIP.apk")}
									size="md"
									variant="link"
								>
									HERE.
								</Button>
							</Text>
						</Accordion.Details>
					</Accordion.Item>
					<Accordion.Item>
						<Accordion.Summary>
							I cannot log into the CIP website or mobile application?
						</Accordion.Summary>
						<Accordion.Details backgroundColor="#f5f5f5">
							After you submitted your member registration via the web portal or
							mobile application it may take up to three working days to verify
							your proof of identify and employment. If you were already
							registered successfully and you have forgotten your login details,
							please use the Forgot Password link on the login screen to reset
							your password. Alternatively contact Support on 011 504 0011 or
							support@vivoincentives.co.za for further assistance.
						</Accordion.Details>
					</Accordion.Item>
				</Accordion>
			</Box>
		);
	};
	const HisenseFAQ = () => {
		return (
			<Box
				m={3}
				style={
					isDesktopOrLaptop[0]
						? { marginHorizontal: 200 }
						: { marginHorizontal: 5, marginBottom: 200 }
				}
			>
				<Accordion space={2.5} allowMultiple>
					<Accordion.Item>
						<Accordion.Summary>
							How the member registration process works?
						</Accordion.Summary>
						<Accordion.Details backgroundColor="#f5f5f5">
							You can register via the web portal or our mobile application by
							clicking on “MEMBER REGISTRATION” and following the prompts. Be
							sure to have a digital copy of your proof of identity as you will
							need to upload it during registration. Once we receive your
							registration request your proof of identity will be moderated and
							your employment verified by the manager registered at that store
							or by a Hisense representative where after your account will be
							activated. A benefit card will be shipped to the store you
							registered with.
						</Accordion.Details>
					</Accordion.Item>
					<Accordion.Item>
						<Accordion.Summary>
							How does the Channel Incentive Programme work?
						</Accordion.Summary>
						<Accordion.Details backgroundColor="#f5f5f5">
							Sales for incentivized devices are claimed for via our web portal
							or mobile application. Claims are moderated and paid out to an
							online wallet. Funds can be transferred from the online wallet to
							the CIP benefit card which can be used to purchase from any point
							of sale system.
						</Accordion.Details>
					</Accordion.Item>
					<Accordion.Item>
						<Accordion.Summary>
							How do I get the Hisense CIP mobile application?
						</Accordion.Summary>
						<Accordion.Details backgroundColor="#f5f5f5">
							<Text>
								From Android devices visit the Google Play store or for Apple
								devices visit the Apple App Store and search for the "Hisense
								CIP" application. From the mobile application you can register,
								submit claims, transfer funds and manage your account.
								Alternatively you are also able to download the android APK file
								to install the app manually by clicking{" "}
								<Button
									padding={0}
									onPress={() => handleDownload("Hisense_CIP.apk")}
									size="md"
									variant="link"
								>
									HERE.
								</Button>
							</Text>
						</Accordion.Details>
					</Accordion.Item>
					<Accordion.Item>
						<Accordion.Summary>
							I cannot log into the CIP website or mobile application?
						</Accordion.Summary>
						<Accordion.Details backgroundColor="#f5f5f5">
							After you submitted your member registration via the web portal or
							mobile application it may take up to three working days to verify
							your proof of identify and employment. If you were already
							registered successfully and you have forgotten your login details,
							please use the Forgot Password link on the login screen to reset
							your password. Alternatively contact Support on 0861 23123 or
							support@hisenseincentives.co.za for further assistance.
						</Accordion.Details>
					</Accordion.Item>
				</Accordion>
			</Box>
		);
	};

	/**
	 * Get in touch
	 */
	const XiaomiGetInTouch = () => {
		return (
			<Center px="5" padding="5">
				<VStack alignItems="center" mx="4" space={2.5}>
					<Heading
						fontWeight="900"
						size={isWeb() ? "md" : "sm"}
						onPress={() => dialCall("0115040010")}
					>
						011 504 0010
					</Heading>
					<Heading
						fontWeight="900"
						size={isWeb() ? "md" : "sm"}
						onPress={() => sendMail("SUPPORT@XIAOMIINCENTIVES.CO.ZA")}
					>
						SUPPORT@XIAOMIINCENTIVES.CO.ZA
					</Heading>
				</VStack>
			</Center>
		);
	};
	const VivoGetInTouch = () => {
		return (
			<Center px="5" padding="5">
				<VStack alignItems="center" mx="4" space={2.5}>
					<Heading
						fontWeight="900"
						size={isWeb() ? "md" : "sm"}
						onPress={() => dialCall("0115040011")}
						style={{ alignItems: "center" }}
					>
						011 504 0011
					</Heading>
					<Heading
						fontWeight="900"
						size={isWeb() ? "sm" : "xs"}
						onPress={() => sendMail("SUPPORT@VIVOINCENTIVES.CO.ZA")}
						style={{ alignItems: "center" }}
					>
						SUPPORT@VIVOINCENTIVES.CO.ZA
					</Heading>
				</VStack>
			</Center>
		);
	};
	const HisenseGetInTouch = () => {
		return (
			<Center px="5" padding="5">
				<VStack alignItems="center" mx="4" space={2.5}>
					<Heading
						fontWeight="900"
						size={isWeb() ? "md" : "sm"}
						onPress={() => dialCall("0115040011")}
						style={{ alignItems: "center" }}
					>
						0861 23123
					</Heading>
					<Heading
						fontWeight="900"
						size={isWeb() ? "md" : "sm"}
						onPress={() => sendMail("SUPPORT@VIVOINCENTIVES.CO.ZA")}
						style={{ alignItems: "center" }}
					>
						SUPPORT@HISENSEINCENTIVES.CO.ZA
					</Heading>
				</VStack>
			</Center>
		);
	};

	/**
	 * How to sign up
	 */
	const XiaomiHowToSignUp = () => {
		return (
			<View style={{ textAlign: "center" }}>
				<VStack alignItems="center" justifyContent="center" mx="4" space={4}>
					<Heading fontWeight="900" size={isWeb() ? "md" : "sm"} center>
						Click the Member Registration button to join the program, or
						download the Xiaomi XIP app.
					</Heading>
					<Heading fontWeight="900" size={isWeb() ? "md" : "sm"}>
						After submitting your registration, your proof of identity will be
						reviewed and your employment verified. There after your benefits
						card will be shipped to the store you are registered with.
					</Heading>
				</VStack>
			</View>
		);
	};
	const VivoHowToSignUp = () => {
		return (
			<View
				style={{
					textAlign: "center",
				}}
			>
				<VStack alignItems="center" mx="3" space={4}>
					<Heading
						fontWeight="900"
						size={isWeb() ? "md" : "sm"}
						letterSpacing={1}
						//width={isWeb() ? "full" : "200"}
					>
						{`
Click the Member Registration button to join the program, or download the vivo CIP app. \n
After submitting your registration, your proof of identity will be reviewed and your employment verified. There after your benefits card will be shipped to the store you are registered with.
`}
					</Heading>
				</VStack>
			</View>
		);
	};
	const HisenseHowToSignUp = () => {
		return (
			<View
				style={{
					textAlign: "center",
				}}
			>
				<VStack alignItems="center" mx="3" space={4}>
					<Heading
						fontWeight="900"
						size={isWeb() ? "md" : "sm"}
						letterSpacing={1}
						//width={isWeb() ? "full" : "200"}
					>
						{`
Click the Member Registration button to join the program, or download the Hisense CIP app. \n
After submitting your registration, your proof of identity will be reviewed and your employment verified. There after your benefits card will be shipped to the store you are registered with.
`}
					</Heading>
				</VStack>
			</View>
		);
	};

	const data = [
		{
			id: "1",
			title: "HOW DOES IT WORK?",
			backgroundColor: "#fff",
			slug: "services",
			content: () => (
				<>
					{isWeb() ? (
						<Image
							resizeMode="contain"
							source={{
								uri: getBrandHowDoesItWorkImage(),
							}}
							style={{
								width: isWeb() ? width / 1.2 : width,
								height: isWeb() ? height / 1.5 : height / 6,
								marginTop: isWeb() ? 0 : 100,
								resizeMode: "stretch",
							}}
						/>
					) : (
						<>
							{Constants.CIP_BRAND === Constants.XiaomiURL ? (
								<Image
									resizeMode="contain"
									source={{
										uri: Image.resolveAssetSource(getBrandHowDoesItWorkImage())
											.uri,
									}}
									style={{
										width: isWeb() ? width / 1.2 : width,
										height: isWeb() ? height / 1.5 : height / 6,
										marginTop: isWeb() ? 0 : 100,
										resizeMode: "stretch",
									}}
								/>
							) : (
								<View
									style={{
										width: width / 1.1,
										height: height / 1.8,
									}}
								>
									<MobileCarousel />
								</View>
							)}
						</>
					)}
				</>
			),
		},
		{
			id: "2",
			title: "HOW TO SIGN UP!",
			backgroundColor: isXiaomi ? "#F5F5F5" : "#ededed",
			slug: "portfolio",
			content: function () {
				switch (Constants.CIP_BRAND) {
					case Constants.XiaomiURL:
						return XiaomiHowToSignUp();
					case Constants.VivoURL:
						return VivoHowToSignUp();
					case Constants.HisenseURL:
						return HisenseHowToSignUp();
				}
			},
		},
		{
			id: "3",
			title: "FAQ'S",
			slug: "faqs",
			backgroundColor: "#fff",
			content: function () {
				switch (Constants.CIP_BRAND) {
					case Constants.XiaomiURL:
						return XiaomiFAQ();
					case Constants.VivoURL:
						return VivoFAQ();
					case Constants.HisenseURL:
						return HisenseFAQ();
				}
			},
		},
		{
			id: "4",
			title: "GET IN TOUCH WITH US",
			slug: "contact",
			backgroundColor: "#ededed",
			content: function () {
				switch (Constants.CIP_BRAND) {
					case Constants.XiaomiURL:
						return XiaomiGetInTouch();
					case Constants.VivoURL:
						return VivoGetInTouch();
					case Constants.HisenseURL:
						return HisenseGetInTouch();
				}
			},
		},
	];

	const handleViewableItemsChanged = useRef(({ viewableItems }) => {
		setViewableItems(viewableItems);
	});

	useEffect(() => {
		if (!viewableItems[0] || currentPage === viewableItems[0].index) return;
		setCurrentPage(viewableItems[0].index);
	}, [viewableItems]);

	const handleNext = () => {
		if (currentPage == data.length - 1) return;
		flatlistRef.current.scrollToIndex({
			animated: true,
			index: currentPage + 1,
		});
	};

	const handleBack = () => {
		if (currentPage == 0) return;
		flatlistRef.current.scrollToIndex({
			animated: true,
			index: currentPage - 1,
		});
	};

	const dialCall = (number) => {
		let phoneNumber = "";
		if (Platform.OS === "android") {
			phoneNumber = `tel:${number}`;
		} else {
			phoneNumber = `telprompt:${number}`;
		}
		Linking.openURL(phoneNumber);
	};

	const sendMail = (mail) => {
		Linking.openURL(`mailto:${mail}`);
	};

	const flatlistItem = ({ item, index }) => {
		return (
			<View
				style={{
					// flex: 1,
					alignItems: "center",
					justifyContent: isWeb() ? "center" : null,
					height: height,
					backgroundColor: item.backgroundColor,
					width: isWeb() ? null : width,
					paddingTop: isWeb() ? 0 : 50,
					marginBottom: 12,
				}}
				id={item.slug}
			>
				{isWeb() ? (
					<>
						<div id={item.slug}></div>
						<View>
							<Heading fontWeight="900" size="lg">
								{item.title}
							</Heading>
							<Divider my="2" />
						</View>
						<View
							style={{
								alignItems: "center",
								justifyContent: "center",
							}}
						>
							{item.content()}
						</View>
					</>
				) : (
					<>
						<View>
							<Heading fontWeight="900" size="lg">
								{item.title}
							</Heading>
							<Divider my="2" />
						</View>

						<View
							style={{
								alignItems: "center",
								justifyContent: "center",
							}}
						>
							<ScrollView style={{ flex: 1 }}>{item.content()}</ScrollView>
						</View>
					</>
				)}
			</View>
		);
	};

	const renderBottomSection = () => {
		return (
			<SafeAreaView>
				<View
					style={{
						flexDirection: "row",
						justifyContent: "space-between",
						alignItems: "center",
						paddingHorizontal: 22,
						paddingVertical: 5,
						// backgroundColor: "#fff",
					}}
				>
					<View style={{ flexDirection: "row", alignItems: "center" }}>
						{
							// No. of dots
							[...Array(data.length)].map((_, index) => (
								<View
									key={index}
									style={{
										width: 12,
										height: 12,
										borderRadius: 6,
										borderColor: colors.primary["200"],
										borderWidth: 1,
										backgroundColor:
											index == currentPage ? colors.primary["600"] : "#fff",
										marginRight: 10 * 2,
									}}
								/>
							))
						}
					</View>
					{currentPage != data.length - 1 ? (
						<TouchableOpacity
							onPress={handleNext}
							style={{
								flexDirection: "row",
								alignItems: "center",
								justifyContent: "center",
								width: 10 * 6,
								height: 10 * 6,
								borderRadius: 10 * 3,
								backgroundColor: colors.primary["400"],
							}}
							activeOpacity={0.8}
						>
							<ChevronRightIcon
								size="6"
								style={{
									color: colors.white,
									opacity: 0.3,
								}}
							/>
							<ChevronRightIcon
								size="8"
								style={{
									color: colors.white,
									marginLeft: -20,
								}}
							/>
						</TouchableOpacity>
					) : (
						<TouchableOpacity
							style={{
								paddingHorizontal: 8,
								height: 10 * 6,
								borderRadius: 10 * 3,
								backgroundColor: colors.primary["400"],
								flexDirection: "row",
								justifyContent: "center",
								alignItems: "center",
							}}
							onPress={() => {
								flatlistRef.current.scrollToIndex({
									animated: true,
									index: 0,
								});
							}}
						>
							<Text
								fontWeight="700"
								style={{
									color: colors.white,
									fontSize: 16,
									marginLeft: 5 * 2,
								}}
							>
								GO BACK
							</Text>
							<ChevronLeftIcon
								size="8"
								style={{
									color: colors.white,
								}}
							/>
							<ChevronLeftIcon
								size="6"
								style={{
									color: colors.white,
									opacity: 0.3,
									marginLeft: -20,
								}}
							/>
						</TouchableOpacity>
					)}
				</View>
			</SafeAreaView>
		);
	};

	return (
		<>
			<FlatList
				data={data}
				pagingEnabled
				horizontal={isWeb() ? false : true}
				showsHorizontalScrollIndicator={false}
				keyExtractor={(item) => item.id}
				renderItem={flatlistItem}
				ref={flatlistRef}
				onViewableItemsChanged={handleViewableItemsChanged.current}
				viewabilityConfig={{ viewAreaCoveragePercentThreshold: 100 }}
				initialNumToRender={1}
				extraData={width}
			/>
			{Platform.OS !== "web" && renderBottomSection()}
		</>
	);
};

export default InfoPages;
